import Vue from "vue";
import Vuex from "vuex";
import api from "axios";

Vue.use(Vuex);
let tries = 0;
const store = new Vuex.Store({
  state: {
    status: "",
    token: localStorage.getItem("token") || "",
    rtoken: localStorage.getItem("rtoken") || "",
    refreshing: false,
    user: localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {},
    users: [],
    filteredGroups: [],
    vadeMecuns: []
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, token, user) {
      state.status = "success";
      state.token = token;
      state.user = user;
    },
    auth_error(state) {
      state.status = "error";
    },
    start_refresh(state) {
      state.refreshing = true;
    },
    auth_refresh(state, newToken) {
      state.refreshing = false;
      state.token = newToken.access_token;
      state.rtoken = newToken.refresh_token;
    },
    logout(state) {
      state.status = "";
      state.rtoken = "";
      state.token = "";
    },
    getting_info(state, user) {
      state.user = user;
      state.filteredGroups = state.user.grupos.filter((el) => el.grupos_id && el.grupos_id.status === 'published');

    },
    get_users(state, users) {
      state.users = users;
    },
    clean_users(state) { 
      state.users = []
    },
    setVadeMecuns(state, vds) { 
      state.vadeMecuns = vds
    }
  },
  actions: {
    cleanUsers({commit}) { 
      commit("clean_users")
    },
    async searchUsuarios({ commit },strSearch) {
      await api({ url: "users?fields=id,first_name,emai,avatar&filter[first_name][_contains]="+strSearch}).then(
        (response) => {
          commit("get_users", response.data.data);
        }
      );
    },
    getUsuarios({ commit }) {
      api({ url: "users?fields=id,first_name,last_name" }).then(
        (response) => {
          commit("get_users", response.data.data);
        }
      );
    },
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        api({ url: "auth/login", data: user, method: "POST" })
          .then((resp) => {
            const token = resp.data.data.access_token;
            // const user = user.email
            const refreshToken = resp.data.data.refresh_token;
            localStorage.setItem("token", token);
            localStorage.setItem("rtoken", refreshToken);
            api.defaults.headers.common["Authorization"] = "Bearer " + token;
            commit("auth_success", token, user);
            window.console.log("auth_success")

            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");

            localStorage.removeItem("token");
            localStorage.removeItem("rtoken");

            localStorage.removeItem("user");
            reject(err);
          })

      });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit("logout");
        localStorage.removeItem("token");
        localStorage.removeItem("rtoken");
        localStorage.removeItem("user");

        delete api.defaults.headers.common["Authorization"];
        resolve();
      });
    },
    refreshToken({ commit }) {
      return new Promise(async (resolve, reject) => {
        if (this.state.rtoken != "") {
          commit("start_refresh");
          await api({
            url: "auth/refresh",
            data: { refresh_token: this.state.rtoken },
            method: "POST",
            headers: { Authorization: "" },
          })
            .then((resp) => {
              // window.console.log(resp.data.data)
              const newToken = resp.data.data;

              api.defaults.headers.common["Authorization"] =
                "Bearer " + newToken.access_token;
              localStorage.setItem("token", newToken.access_token);
              localStorage.setItem("rtoken", newToken.refresh_token);
              commit("auth_refresh", newToken);

              resolve(resp);
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    realoadVadeMecuns({ commit }) { 
      return new Promise(async (resolve) => { 
          const query = `query FilterVadeMecumsByApelidosLeis($user_id:String){
              vademecums(sort: ["-date_created"], filter: { status: {_in : ["published", "public", "private"] }, user_created: { id: { _eq: $user_id}}}) {
                id
                titulo
                cor
                leis {
                  id
                  leis_id_lei { 
                    id_lei
                    numero_lei
                    data_lei  
                    nome_lei
                    apelidos_leis (sort:["-date_created"], filter: { user_created: { id: { _eq: $user_id}}}){
                        id
                        apelido
                    }
                  }
                }
              }
          }`
    
          const variables = { user_id: this.state.user.id };
          const {data: {data }} = await api.post("/graphql", {
            query,
            variables,
          });
          //window.console.log(data)
          commit("setVadeMecuns",data.vademecums);
          resolve(data)
      })
    },
    getInfo({ commit }) {
      return new Promise((resolve) => {
        api({ url: "/users/me?fields=*,grupos.grupos_id.nome_grupo,grupos.grupos_id.id,grupos.grupos_id.imagem_grupo,grupos.grupos_id.integrantes,grupos.grupos_id.status" })
          .then((resp) => {
            // window.console.log(resp.data.data)
            let tmpUser = resp.data.data;
            if (tmpUser.id) {
              localStorage.setItem("user", JSON.stringify(tmpUser));
              commit("getting_info", tmpUser);
            }
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);
          });
      });
    },
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
  },
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  function (err) {
    return new Promise(async (resolve, reject) => {
      if (err.response != undefined) {
        if (
          err.response.status === 401 &&
          err.response.config.url == "auth/refresh"
        ) {
          store.state.refreshing = true
          store.dispatch("logout");
          window.console.log("tomou logout");
          reject(err);
        }
        if (err.response.status === 401 && !store.state.refreshing && err.response.config.url !== "auth/login" && tries < 3) {
          tries++
          await store.dispatch("refreshToken");
          // window.console.log(err.config);
          err.config.headers.Authorization = "Bearer " + store.state.token;
          return api(err.config);
        }
      }
       reject(err);
    });
  }
);

export default store;
